<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
       <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical"
          @open="handleOpen"
          @close="handleClose"
          background-color="#ffffff"
          text-color="#000000"
          active-text-color="#409EFF">
          <SidebarItem v-for="(item,index) in dataList" :key="index"  :item="item" />
        </el-menu>
    </el-scrollbar>
</template>

<script>
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  data() {
    return {
      dataList:[
        {
          'key':'dashboard',
          'title':this.$root.lang.navMenu.dashboard,
          'path':'/dashboard'
        },
        {
          'key':'develop',
          'title':this.$root.lang.navMenu.develop,
          'kindOne':[
              {
                'key':'device',
                'title':this.$root.lang.navMenu.developItem.device,
                'path':'/develop/device'
              },
              {
                'key':'app',
                'title':this.$root.lang.navMenu.developItem.app,
                'path':'/develop/app'
              },
              {
                'key':'appstore',
                'title':this.$root.lang.navMenu.developItem.appstore,
                'path':'/develop/appstore'
              },
          ]
        },
        {
          'key':'stock',
          'title':this.$root.lang.navMenu.stock,
          'kindOne':[
            {
              'key':'record',
              'title':this.$root.lang.navMenu.stockItem.record,
              'path':'/stock/index'
            },
            {
              'key':'expired',
              'title':this.$root.lang.navMenu.stockItem.expired,
              'path':'/stock/expired'
            },
            {
              'key':'set',
              'title':this.$root.lang.navMenu.stockItem.set,
              'path':'/stock/set'
            }
          ]
        },
        {
          'key':'log',
          'title':this.$root.lang.navMenu.log,
          'kindOne':[
            {
              'key':'report',
              'title':this.$root.lang.navMenu.logItem.report,
              'path':'/log/report'
            },
            {
              'key':'operate',
              'title':this.$root.lang.navMenu.logItem.operate,
              'path':'/log/operate'
            },
            {
              'key':'login',
              'title':this.$root.lang.navMenu.logItem.login,
              'path':'/log/login'
            }
          ]
        },
        {
          'key':'config',
          'title':this.$root.lang.navMenu.config,
          'kindOne':[
            {
              'key':'type',
              'title':this.$root.lang.navMenu.configItem.type,
              'path':'/config/type'
            },
          ]
        },
        {
          'key':'ams',
          'title':this.$root.lang.navMenu.ams,
          'path':'/ams/index'
        },
        {
          'key':'user',
          'title':this.$root.lang.navMenu.user,
          'kindOne':[
            {
              'key':'all',
              'title':this.$root.lang.navMenu.userItem.allUser,
              'path':'/user/index'
            },
            {
              'key':'visual',
              'title':this.$root.lang.navMenu.userItem.visualUser,
              'path':'/user/visual'
            },
            {
              'key':'block',
              'title':this.$root.lang.navMenu.userItem.blocklUser,
              'path':'/user/block'
            },
            {
              'key':'ulog',
              'title':this.$root.lang.navMenu.userItem.logUser,
              'path':'/user/log'
            }
          ]
        },
        {
          'key':'visualData',
          'title':this.$root.lang.navMenu.visual,
          'kindOne':[
            {
              'key':'vtype',
              'title':this.$root.lang.navMenu.visualItem.visualType,
              'path':'/visual/vtype'
            },
            {
              'key':'page',
              'title':this.$root.lang.navMenu.visualItem.visualPage,
              'path':'/visual/page'
            }
          ]
        },
         {
          'key':'FirmwareVersion',
          'title':"固件管理",
          'kindOne':[
            {
              'key':'FirmwareVersion',
              'title':"固件上传",
              'path':'/FirmwareVersion/index'
            },
            {
              'key':'Remoteupgrade',
              'title':"远程固件升级",
              'path':'/FirmwareVersion/Remoteupgrade'
            },
          ]
        },
        {
          'key':'blockChain',
          'title':this.$root.lang.navMenu.block,
          'kindOne':[
            {
              'key':'chain',
              'title':this.$root.lang.navMenu.blockItem.blockPage,
              'path':'/block/page'
            },
            {
              'key':'map',
              'title':this.$root.lang.navMenu.blockItem.blockMap,
              'path':'/block/map'
            },
            {
              'key':'contract',
              'title':this.$root.lang.navMenu.blockItem.blockContract,
              'path':'/block/contract'
            }
          ]
        },
        {
          'key':'test',
          'title':this.$root.lang.navMenu.test,
          'path':'/test'
        },
       
        {
          'key':'payOrder',
          'title':this.$root.lang.navMenu.order,
          'kindOne':[
            {
              'key':'order',
              'title':this.$root.lang.navMenu.orderItem.orderPage,
              'path':'/order/page'
            },
            {
              'key':'notify',
              'title':this.$root.lang.navMenu.orderItem.notifyPage,
              'path':'/order/notify'
            }
          ]
        },
        {
          'key':'Invoice',
          'title':this.$root.lang.navMenu.invoice,
          'kindOne':[
            {
              'key':'invoice',
              'title':this.$root.lang.navMenu.invoiceItem.invoicePage,
              'path':'/invoice/page'
            },
            {
              'key':'info',
              'title':this.$root.lang.navMenu.invoiceItem.infoPage,
              'path':'/invoice/info'
            },
            {
              'key':'manager',
              'title':this.$root.lang.navMenu.invoiceItem.managerPage,
              'path':'/invoice/manager'
            }
          ]
        },
        {
          'key':'applicationtype',
          'title':this.$root.lang.navMenu.applicationtype,
          'path':'/applicationtype'
        },
        //逆变器管理
        {
          'key':'Invertermanagement',
          'title':this.$root.lang.navMenu.Invertermanagement,
          'kindOne':[
            {
              'key':'Invertermanagement',
              'title':this.$root.lang.navMenu.InvertermanagementItem.InvertermanagementIndex,
              'path':'/Invertermanagement/index'
            },
            {
              'key':'user',
              'title':this.$root.lang.navMenu.InvertermanagementItem.UserList,
              'path':'/Invertermanagement/user'
            },
            {
              'key':'Invertermodel',
              'title':this.$root.lang.navMenu.InvertermanagementItem.Invertermodel,
              'path':'/Invertermanagement/Invertermodel'
            },
            {
              'key':'InverterInformation',
              'title':this.$root.lang.navMenu.InvertermanagementItem.InverterInformation,
              'path':'/Invertermanagement/InverterInformation'
            },
          ]
        },
        //采集棒平台管理
        {
          'key':'collectionrod',
          'title':this.$root.lang.navMenu.collectionrod,
          'path':'/collectionrod'
        },
        {
          'key':'tesxt',
          'title':"运维管理",
          'kindOne':[
            {
              'key':'devicestatus',
              'title':"设备状态管理",
              'path':'/devicestatus'
            },
            {
              'key':'devicestatusrun',
              'title':"设备及应用运行状态统计",
              'path':'/devicestatusrun'
            },
            // {
            //   'key':'deviceinteraction',
            //   'title':"设备交互",
            //   'path':'/deviceinteraction'
            // },
            {
              'key':'deviceabnormal',
              'title':"设备异常运维配置",
              'path':'/deviceabnormal'
            },
            {
              'key':'deviceexception',
              'title':"设备异常统计",
              'path':'/deviceexception'
            },
          ]
        },
        //broker
        {
          'key':'BROKER',
          'title':"BROKER配置",
          'kindOne':[
            {
              'key':'broker',
              'title':"JIS Borker用户",
              'path':'/broker'
            },
            {
              'key':'SSHEQM',
              'title':"远程连接SSH设备管理",
              'path':'/SSHEQM'
            },
            {
              'key':'directives',
              'title':"指令管理",
              'path':'/directives'
            },
           
          ]
        },
        {
              'key':'ssllog',
              'title':"SSL日志管理",
              'path':'/ssllog'
            },
            {
              'key':'nobroker',
              'title':"非JIS Broket用户",
              'path':'/nobroker'
            },
        //ai聊天
        {
          'key':'ai',
          'title':"聊天对话框",
          'path':'/ai'
        },
        // 设备状态管理
        // {
        //   'key':'devicestatus',
        //   'title':"设备状态管理",
        //   'path':'/devicestatus'
        // },
        // {
        //   'key':'devicestatusrun',
        //   'title':"设备及应用运行状态统计",
        //   'path':'/devicestatusrun'
        // },
      ]
    }
  },
  computed: {
    onRoutes(){
      return this.$root.defaultActive;
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    getRoute(str) {
      if(this.$route.path.indexOf(str) > 0) return true;
      else return false;
    }
  }
}
</script>

<style type="text/c" rel="stylesheet/scss" lang="scss" scoped>
#app .el-menu-vertical {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue